var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.146,
    height: 15.529,
    viewBox: "0 0 21.146 15.529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tick",
    transform: "translate(0 -67.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_986",
    "data-name": "Group 986",
    transform: "translate(0 67.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M20.836,68.307a1.057,1.057,0,0,0-1.5,0L6.674,80.975,1.8,76.105a1.057,1.057,0,0,0-1.5,1.5l5.617,5.617a1.058,1.058,0,0,0,1.5,0L20.836,69.8A1.057,1.057,0,0,0,20.836,68.307Z",
    transform: "translate(0 -67.998)",
    fill: "#67E1AE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.b37dc2eb608524cb628be79f5a7b7ffa.svg";
export { ForwardRef as ReactComponent };